import { companyConstants } from '../_constants';

export function companyCreationReducer(state = {}, action) {
  switch (action.type) {
    case companyConstants.COMPANY_CREATION_REQUEST:
      return {
        created: true
      }
    case companyConstants.COMPANY_CREATION_SUCCESS:
      return {
        created: true
      }
    case companyConstants.COMPANY_CREATION_FAILURE:
      return {
        created: false
      }
    default:
      return {
        created: {}
      }
  }
}

export function companyNotFinishedRemovalReducer(state = {}, action) {
  switch (action.type) {
    case companyConstants.COMPANY_NOT_FINISHED_REMOVAL_REQUEST:
      return {
        created: true
      }
    case companyConstants.COMPANY_NOT_FINISHED_REMOVAL_SUCCESS:
      return {
        created: true
      }
    case companyConstants.COMPANY_NOT_FINISHED_REMOVAL_FAILURE:
      return {
        created: false
      }
    default:
      return {
        created: {}
      }
  }
}